/** Bucățile de adresă ale cazurilor, într-un singur loc.
 *
 *  Erau două liste identice — una în App.tsx, una în entry-prerender.tsx —
 *  fiindcă App montează BrowserRouter, care are nevoie de `window`, deci
 *  prerandarea are propriul arbore de rute. Adăugând un caz doar în App,
 *  ruta exista în browser dar cădea în 404 la prerandare: pagina se vedea
 *  perfect la navigare și ajungea goală la crawler. Un singur export face
 *  devierea imposibilă. */
export const CASE_SLUGS = [
  "erp",
  "vision",
  "commerce",
  "trading",
  "createli",
  "elegance",
  "actexpress",
] as const;

/** Cele patru care apar pe pagina principală. Restul se văd la /work.
 *
 *  Secțiunea „Selected work" e singura de pe landing cu imagini, deci singura
 *  care se citește dintr-o privire — iar șapte carduri cu captură pe telefon
 *  însemnau vreo 3500px de derulat printr-o dovadă care se face din primele
 *  două. Patru arată aceeași gamă: un sistem intern, un magazin, un site de
 *  prezentare, o platformă de rezervări.
 *
 *  Nu e o listă de „preferate": e o selecție. De aceea butonul „Toate
 *  lucrările" stă imediat sub grilă, iar /work rămâne singurul loc care le
 *  arată pe toate șapte. */
export const HOME_CASE_SLUGS: readonly string[] = ["erp", "commerce", "createli", "elegance"];
